// extracted by css-extract-rspack-plugin
export default {"modalRoot":"hOE1yG","modalBackdrop":"qpMPon","modalContainer":"iYNkgX","modalWindowWrapper":"OYREDx","modalWindow":"Wpx_NY"};